module.exports = __webpack_public_path__ + "img/right.83d1d273.svg";